module.exports = __webpack_public_path__ + "18eedcd27a7a4edc837f6de361e9a026.jpg";